import request from '@/utils/request'

export function getOrderList(data) {
  return request({
    url: 'api/v1/order/getOrderList',
    method: 'post',
    data: data,
    timeout: 1000000000
  })
}

export function getOrderStatistsList(data) {
  return request({
    url: 'api/v1/order/getOrderStatistsList',
    method: 'post',
    data: data
  })
}

export function getBill(data) {
  return request({
    url: 'api/v1/order/getBill',
    method: 'post',
    data: data
  })
}

export function handleBill(data) {
  return request({
    url: 'api/v1/order/handleBill',
    method: 'post',
    data: data
  })
}

export function handleAdIncomes(data) {
  return request({
    url: 'api/v1/order/handleAdIncomes',
    method: 'post',
    data: data
  })
}

export function getAdIncomes(data) {
  return request({
    url: 'api/v1/order/getAdIncomes',
    method: 'post',
    data: data
  })
}

export function getAdBill(data) {
  return request({
    url: 'api/v1/order/getAdBill',
    method: 'post',
    data: data
  })
}

export function importAdBill(data) {
  return request({
    url: 'api/v1/order/importAdBill',
    method: 'post',
    data: data
  })
}

export function importBill(data) {
  return request({
    url: 'api/v1/order/importBill',
    method: 'post',
    data: data
  })
}

export function exportOrder(data) {
  return request({
    url: 'api/v1/order/export',
    method: 'post',
    data: data,
    timeout: 100000000000
  }
  )
}

